import React from "react";
import ImageUploadField from "./ImageUploadField";

export default function PoliticalProfileTab({ form, set, personaluid }) {
    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Profile Information</div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label small">Full Name *</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.name}
                                onChange={(e) => set("name", e.target.value)}
                                placeholder="e.g. Rajendra Singh"
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Position / Title</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.position_title}
                                onChange={(e) => set("position_title", e.target.value)}
                                placeholder="e.g. Member of Parliament"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label small">Political Party</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.party}
                                onChange={(e) => set("party", e.target.value)}
                                placeholder="e.g. Nepali Congress"
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Tagline</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.tagline}
                                onChange={(e) => set("tagline", e.target.value)}
                                placeholder="e.g. Serving the people"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label small">Phone</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.phone}
                                onChange={(e) => set("phone", e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Email</label>
                            <input
                                className="form-control form-control-sm"
                                type="email"
                                value={form.email}
                                onChange={(e) => set("email", e.target.value)}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label small">Address / Constituency</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.address}
                                onChange={(e) => set("address", e.target.value)}
                                placeholder="e.g. Kathmandu District"
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Website URL</label>
                            <input
                                className="form-control form-control-sm"
                                value={form.website}
                                onChange={(e) => set("website", e.target.value)}
                                placeholder="https://example.com"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label small">Profile Photo</label>
                            <ImageUploadField
                                value={form.photo}
                                onChange={(v) => set("photo", v)}
                                purpose="logo"
                                personaluid={personaluid}
                                placeholder="Upload your photo"
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Cover Image</label>
                            <ImageUploadField
                                value={form.cover}
                                onChange={(v) => set("cover", v)}
                                purpose="cover"
                                personaluid={personaluid}
                                placeholder="Upload cover image"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">About / Biography</div>
                <div className="card-body">
                    <textarea
                        rows="5"
                        className="form-control form-control-sm"
                        placeholder="Write your biography, background, and political career..."
                        value={form.about}
                        onChange={(e) => set("about", e.target.value)}
                    />
                    <small className="form-text text-muted mt-1">This appears on your public profile page.</small>
                </div>
            </div>
        </div>
    );
}